import { useEffect, useState } from 'react';
import ThemeContext from '../utils/contexts/themeContext';
const ThemeProvider = ({theme = 'dark' , ...props})=>{
const queryParm = new URLSearchParams(window.location.search);
const [themeMode,setThemeMode] = useState(theme);
useEffect(()=>{
const themeMode = queryParm.get('theme'); 
let defaultTheme = 'white';   
if(themeMode){
defaultTheme = themeMode;
}
setThemeMode(defaultTheme);
},[]);
 return <ThemeContext.Provider value = {themeMode}>
  {
  props.children
  }
 </ThemeContext.Provider>
};

export default ThemeProvider;